import classNames from 'classnames'
import * as React from 'react'

import { TooltipInput } from '../../../main/components/tooltip-input'
import { CreateAlertInputProps } from './types'

type PriceInputProps = {
  name: 'priceAbove' | 'priceBelow'
  label: string
} & CreateAlertInputProps

export function PriceInput({ name, label, ...props }: PriceInputProps) {
  const [rawValue, setRawValue] = React.useState(props.state[name] ?? '')

  const handleBlur = React.useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      const price = ev.currentTarget.valueAsNumber

      if (price > 0 && props.errors?.[name]) props.setErrors((errors) => ({ ...errors, [name]: false }))
      props.setState((prev) => ({ ...prev, [name]: price }))
    },
    [name, props]
  )

  const tooltipContent = props.errors?.[name] ? 'Invalid number, please enter a positive number' : undefined

  React.useEffect(() => {
    const priceValue = Number(props.state[name] !== '' ? props.state[name] : undefined)
    if (!isNaN(priceValue)) setRawValue(priceValue.toString())
  }, [name, props.state])

  return (
    <TooltipInput
      isMobileStyleEnabled={false}
      name={name}
      label={label}
      showNumberStepper={false}
      error={!!tooltipContent}
      type="number"
      className={classNames({ 'is-error': props.errors?.[name] })}
      value={rawValue}
      onChange={(ev) => setRawValue(ev.currentTarget.value)}
      onBlur={handleBlur}
      tooltipColor="red"
      tooltipContent={tooltipContent}
      isInteractive
    />
  )
}
